<script setup lang="ts">
import { Toaster, type ToasterProps } from "vue-sonner";
import "vue-sonner/style.css";

const props = defineProps<ToasterProps>();

function makeRichColor(name: string) {
	const cssColorName = `--color-${name}`;

	const bg = `color-mix(in oklab, var(${cssColorName}) 14%, var(--color-base-100))`;
	const fg = `var(${cssColorName})`;
	const border = `color-mix(in oklab, var(${cssColorName}) 18%, var(--color-base-100))`;

	return {
		[`--${name}-bg`]: bg,
		[`--${name}-text`]: fg,
		[`--${name}-border`]: border,
	};
}
</script>

<template>
	<Toaster
		class="toaster group"
		:style="{
			'--normal-bg': 'var(--color-popover)',
			'--normal-text': 'var(--color-popover-content)',
			'--normal-border': 'var(--color-border)',

			...makeRichColor('info'),
			...makeRichColor('success'),
			...makeRichColor('warning'),
			...makeRichColor('error'),
		}"
		v-bind="props"
	/>
</template>
